export enum EventCardSubtitleEnum {
  ALREADY_BOOKED = 'Déjà réservé',
  FULLY_BOOKED = 'Complet',
  NOT_ENOUGH_CREDIT = 'Crédit insuffisant',
  UNAVAILABLE = 'Indisponible',
}

export enum BottomBannerTextEnum {
  NOT_ELIGIBLE = 'Tu ne peux pas réserver cette offre car tu n’es pas éligible au pass Culture.',
  CREDIT_HAS_EXPIRED = 'Tu ne peux pas réserver cette offre car ton crédit a expiré.',
  NOT_ENOUGH_CREDIT = 'Tu ne peux pas réserver cette offre car ton crédit est insuffisant.',
  ALREADY_BOOKED = 'Tu ne peux réserver ce film qu’une seule fois.',
}
